import { Box } from '@mui/material';
import React from 'react';

import Card from '@/contents/General/Card';

type Props = {
  title: string;
  imageUrl: string;
};

const IllustLabList = ({ title, imageUrl }: Props) => {
  return (
    <Box paddingBottom={4}>
      <Card
        variant="normal"
        cardSize="sm"
        title={title}
        imageUrl={imageUrl}
        noElipsis
        noPointer
      />
    </Box>
  );
};

export default IllustLabList;
